export default {
  SHOW_ERROR: '@@errors/SHOW_ERROR',
  CLEAR_ERROR: '@@errors/CLEAR_ERROR',
};
